import styled from 'styled-components';

export const StyledVoucherDetails = styled.div`
  display: flex;
  flex-direction: column;
`;
export const StyledVoucherError = styled.div`
  display: grid;
`;

export const StyledRow = styled.div`
  display: flex;
`;

export const StyledCell = styled.div`
  display: flex;
`;

export const StyledLabel = styled(StyledCell)`
  min-width: 220px;
`;
export const StyledStrong = styled.strong`
  display: block;
  margin-bottom: 10px;
`;
